import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';

const slug = {
  es: ['ferries-desde-alicante', 'ferries-desde-barcelona', 'ferries-a-oran', 'ferries-a-mostaganem', 'ferries-a-argel', 'atencion-al-cliente', 'sobre-romeu-ferries'],
  fr: ['ferries-d-alicante', 'ferries-d-barcelona', 'ferries-a-oran', 'ferries-a-mostaganem', 'ferries-a-argel', 'attention-au-client', 'a-propos-des-ferries-romeu']
}

class sectionInformationBoxes extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  onClick = (to) => {
    window.scrollTo(0, 0)
    this.context.router.history.push(to)
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langHeader = languages[langUrl].header
    const langPlace = languages[langUrl].information

    const path = this.context.router.route.location.pathname
    const lang = path.split('/')[1]
    return (
      <div className="container-fluid">

          <section className="section-information-boxes row">
            <div className="container">
              <div className="row">
                <div className="information-box col-md-4">
                  <div className="information-content">
                    <p className="no-margin pre-title light">{langPlace.attentiontitle}</p>
                    <p className="h2 no-margin small-title bold">{langPlace.attentionsubtitle}</p>
                    <div className="dot"></div>
                    <p className="light">{langPlace.attentiontext}</p>
                    <p className="no-margin light">+34 965 14 70 10</p>
                    <p className="no-margin light">
                      <span>
                      <a className="link" href="mailto:pasajes@romeuycia.com">pasajes@romeuycia.com</a>
                      </span>
                    </p>
                    <div className="line"></div>
                    <p className="small light "><i className="fa fa-chevron-circle-right" aria-hidden="true"></i>
                    <span className="link" onClick={() => this.onClick(`/${lang}/${slug[lang][5]}`)}>{langPlace.formtitle}</span>
                  </p>
                  </div>
                </div>
                <div className="information-box col-md-4">
                  <div className="information-content">
                    <p className="no-margin pre-title light">{langPlace.routestitle}</p>
                    <p className="h2 no-margin small-title bold">{langPlace.routessubtitle}</p>
                    <div className="dot"></div>
                    <p className="light">{langPlace.routestext}</p>
                    <p className="no-margin bold ">
                      <span className="link" onClick={() => this.onClick(`/${lang}/${slug[lang][0]}`)}>
                        {langHeader.ferrysalicante}
                      </span>
                    </p>
                    <div className="line"></div>
                    <p className="no-margin bold ">
                      <span className="link" onClick={() => this.onClick(`/${lang}/${slug[lang][1]}`)}>
                        {langHeader.ferrysbarcelona}
                      </span>
                    </p>
                    <div className="line"></div>
                    <p className="no-margin bold ">
                      <span className="link" onClick={() => this.onClick(`/${lang}/${slug[lang][2]}`)}>
                        {langHeader.ferrysoran}
                      </span>
                    </p>
                    <div className="line"></div>
                    <p className="no-margin bold ">
                      <span className="link" onClick={() => this.onClick(`/${lang}/${slug[lang][3]}`)}>
                        {langHeader.ferrysmostaganem}
                      </span>
                    </p>
                    <div className="line"></div>
                    <p className="no-margin bold ">
                      <span className="link" onClick={() => this.onClick(`/${lang}/${slug[lang][4]}`)}>
                        {langHeader.ferrysargel}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="information-box col-md-4">
                  <div className="information-content">
                    <p className="no-margin pre-title light">{langPlace.abouttitle}</p>
                    <p className="h2 no-margin small-title bold">{langPlace.aboutsubtitle}</p>
                    <div className="dot"></div>
                    <p className="light">{langPlace.abouttext}</p>
                    <div className="line"></div>
                    <p className="small light "><i className="fa fa-plus-circle" aria-hidden="true"></i>
                    <span className="link" onClick={() => this.onClick(`/${lang}/${slug[lang][6]}`)}>{langPlace.knowmorre}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </section>

      </div>
    );
  }
}

export default connect(
	(state) => ({settings: state.settings})
)(sectionInformationBoxes)



// WEBPACK FOOTER //
// ./src/shared/routes/components/sectionInformationBoxes.js